import Widget from '../Widget/Widget';

export default class OmniSearchButtonIcon extends Widget {

}
